import Link from "next/link";
import Analytics from "@/lib/analytics";

type OutboundLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
};

const OutboundLink = ({ children, className, href }: OutboundLinkProps) => {
  const handleClick = () => {
    Analytics.handleOutboundClick(href);
  };

  return (
    <Link
      href={href}
      className={className}
      target="_blank"
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

export default OutboundLink;
